<template>
  <button
    :id="card.slug || undefined"
    class="block w-full text-left active:opacity-80 transition-opacity duration-100 anchor-scroll-margin"
    :data-event-tracking="trackingId"
    @pointerdown="onPointerDown"
    @click="onClick"
  >
    <!-- Fixed 3:2 frame holds the layout while the image streams in; cover-crops wrong ratios -->
    <div
      class="relative w-full aspect-[3/2] rounded-2xl overflow-hidden bg-grey-10 shadow-[0px_1px_10px_0px_rgba(0,0,0,0.1)]"
    >
      <img
        v-if="card.image?.url"
        :src="card.image.url"
        alt=""
        class="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  </button>
</template>

<script>
export default {
  name: 'MoreBannerCard',
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  emits: ['card-click'],
  data() {
    return { pointerStart: null };
  },
  computed: {
    trackingId() {
      // Prefer the CMS slug; otherwise derive one from the destination —
      // e.g. https://gens.app/give#top → gens-app-give
      if (this.card.slug) return `gensapp-more-${this.card.slug}`;
      const slug = (this.card.url || 'card')
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/[?#].*$/, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60);
      return `gensapp-more-${slug || 'card'}`;
    },
  },
  methods: {
    onPointerDown(e) {
      this.pointerStart = { x: e.clientX, y: e.clientY };
    },
    // Dragging the Glider carousel releases on top of a card and fires click —
    // only treat it as a tap when the pointer barely moved.
    onClick(e) {
      const start = this.pointerStart;
      this.pointerStart = null;
      if (start && (Math.abs(e.clientX - start.x) > 10 || Math.abs(e.clientY - start.y) > 10)) {
        return;
      }
      this.$emit('card-click', this.card);
    },
  },
};
</script>
